import { render, staticRenderFns } from "./MarketingPage1.vue?vue&type=template&id=15c9a3bc&"
import script from "./MarketingPage1.vue?vue&type=script&lang=js&"
export * from "./MarketingPage1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports